<ng-container>
    <app-header></app-header>
    <app-menu [type]="layout?.components?.headerType"></app-menu>
    <nb-layout>
        <nb-layout-column>
            <router-outlet></router-outlet>
        </nb-layout-column>
    </nb-layout>
    <app-footer [type]="layout?.components?.footerType"></app-footer>
</ng-container>

<ng-template #skeletonLoader>
    <div>
        <ngx-skeleton height="42px" margin="4px 16px 4px 16px"></ngx-skeleton>
        <ngx-skeleton height="99px" margin="0 16px 16px"></ngx-skeleton>
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <ngx-skeleton height="470px"></ngx-skeleton>
                </div>
                <div class="col-lg-4">
                    <ngx-skeleton height="140px" margin="0 0 24px 0"></ngx-skeleton>
                    <ngx-skeleton height="140px" margin="0 0 24px 0"></ngx-skeleton>
                    <ngx-skeleton height="140px" margin="0 0 0 0"></ngx-skeleton>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-lg-6">
                    <ngx-skeleton height="200px"></ngx-skeleton>
                </div>
                <div class="col-lg-6">
                    <ngx-skeleton height="200px"></ngx-skeleton>
                </div>
                <div class="col-lg-6">
                    <ngx-skeleton height="200px"></ngx-skeleton>
                </div>
                <div class="col-lg-6">
                    <ngx-skeleton height="200px"></ngx-skeleton>
                </div>
            </div>
        </div>
    </div>
</ng-template>
